import { Phone, Mail, MapPin, Clock, MessageCircle } from "lucide-react";
import { PageHero } from "../components/sections";
import { Reveal } from "../components/Reveal";
import { EnquiryForm } from "../components/EnquiryForm";
import { COMPANY, IMAGES } from "../data/site";

export default function Contact() {
  return (
    <div>
      <PageHero eyebrow="Get in Touch" title="Let's plan your journey" subtitle="Call, message or drop by our Pune office. Our travel experts are always happy to help." image={IMAGES.tropical} />

      <section className="ll-container ll-section grid lg:grid-cols-2 gap-14">
        <Reveal>
          <p className="eyebrow text-[#f7ad2d]">Contact Details</p>
          <h2 className="font-display text-4xl font-bold mt-3 mb-8">We&apos;d love to hear from you</h2>

          <div className="space-y-6">
            <a href={`tel:${COMPANY.phones[0].replace(/\s/g, "")}`} data-testid="contact-phone" className="flex gap-4 group">
              <div className="w-12 h-12 rounded-2xl bg-[#4ef72d]/15 flex items-center justify-center shrink-0"><Phone size={20} className="text-[#0A221C]" /></div>
              <div>
                <p className="text-sm text-[#4A5D58]">Call us</p>
                {COMPANY.phones.map((p) => <p key={p} className="font-semibold text-[#0A221C] group-hover:text-[#4ef72d] transition-colors">{p}</p>)}
              </div>
            </a>
            <a href={`mailto:${COMPANY.email}`} data-testid="contact-email" className="flex gap-4 group">
              <div className="w-12 h-12 rounded-2xl bg-[#4ef72d]/15 flex items-center justify-center shrink-0"><Mail size={20} className="text-[#0A221C]" /></div>
              <div>
                <p className="text-sm text-[#4A5D58]">Email us</p>
                <p className="font-semibold text-[#0A221C] group-hover:text-[#4ef72d] transition-colors break-all">{COMPANY.email}</p>
              </div>
            </a>
            <div className="flex gap-4">
              <div className="w-12 h-12 rounded-2xl bg-[#4ef72d]/15 flex items-center justify-center shrink-0"><MapPin size={20} className="text-[#0A221C]" /></div>
              <div>
                <p className="text-sm text-[#4A5D58]">Visit us</p>
                <p className="font-semibold text-[#0A221C] leading-relaxed">{COMPANY.address}</p>
              </div>
            </div>
            <div className="flex gap-4">
              <div className="w-12 h-12 rounded-2xl bg-[#4ef72d]/15 flex items-center justify-center shrink-0"><Clock size={20} className="text-[#0A221C]" /></div>
              <div>
                <p className="text-sm text-[#4A5D58]">Office hours</p>
                <p className="font-semibold text-[#0A221C]">Mon – Sat, 10:00 AM – 7:00 PM</p>
              </div>
            </div>
            <a href={`https://wa.me/${COMPANY.whatsapp}`} target="_blank" rel="noreferrer" data-testid="contact-whatsapp" className="inline-flex items-center gap-2 bg-[#25D366] text-white px-6 py-3.5 rounded-full font-semibold hover:scale-[1.02] transition-transform">
              <MessageCircle size={20} /> Chat on WhatsApp
            </a>
          </div>

          <div className="rounded-3xl overflow-hidden border border-black/5 h-72 mt-10">
            <iframe title="Life Line Pune Office" src={COMPANY.mapEmbed} width="100%" height="100%" style={{ border: 0 }} loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="ll-card p-8 lg:sticky lg:top-28">
            <h3 className="font-display text-2xl font-bold mb-2">Send us an enquiry</h3>
            <p className="text-[#4A5D58] mb-7">Fill this in and we&apos;ll call you back shortly.</p>
            <EnquiryForm packageName="Contact Page" />
          </div>
        </Reveal>
      </section>
    </div>
  );
}
